import { render, staticRenderFns } from "./SelloIndex.vue?vue&type=template&id=19a554f7"
import script from "./SelloIndex.vue?vue&type=script&lang=js"
export * from "./SelloIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports